import { ACCESS_VERSION } from '../services/access.service';

export enum BookAccessCodeTypes {
    BUNDLE = 'bundle',
    DIGIBOOK = 'digi',
    EBOOK = 'lemberger',
    STORE = 'store-at',
    D4S = 'digi4school'
}

export interface BookAccessCode {
    version: ACCESS_VERSION;
    isbn: string | null;
    bookId: number;
    quickLink: string;
    pin: string | null;
    type: BookAccessCodeTypes;
    userId: number;
    hash: string | null;
    canUpgrade: boolean;
    trialAvailable?: boolean;
    trialDays?: number;
}

export interface GmtAccessCode {
    hash: string | null;
    userId: number;
    quickLink: string;
}

export interface Digi4SchoolCode {
    code: string;
    bookId: number;
    userId: number;
    isbn: string;
}

export interface AccessTo {
    bookEdit: boolean;
    copyToSchoolbag: boolean;
    dashboard: boolean;
    schoolClass: boolean;
}

export interface AccessCode {
    cover: string;
    code: string;
    resourceName: string;
    used: number;
    pin: string | null;
    type: string;
    hash: string;
    version: ACCESS_VERSION;
    canUpgrade: boolean;
    trialAvailable?: boolean;
    trialDays?: number;
}

export class UserData {
    id: number;
    loggedIn: boolean;
    firstName: string;
    lastName: string;
    username: string;
    email: string;
    accessTo: AccessTo;
    bookAccessCode: BookAccessCode | null;
    digi4SchoolCode: Digi4SchoolCode | null;
    digi4SchoolUser: boolean;
    isAdminSession: boolean;
    gmtCode: GmtAccessCode | null;
    isTeacher: boolean;
    isAdmin: boolean;
    merged: boolean;
    isWhiteboardAuthor: boolean;
    accessCodeSelected: boolean;
    accessCodes: Array<AccessCode> | null;
    userIdentifier: number | string | null;
    permissions: any;
}
